import { createContext, useContext } from "react";
import { PromptLibraryItemSource } from "@/modules/promptLibrary/promptLibrary.types";

export interface PromptToApply {
  source: PromptLibraryItemSource;
  prompt: string;
}

interface PromptLibraryContextState {
  subscribe: (cb: (prompt: string) => void) => () => void;
  emit: (prompt: string) => void;
  openCreatePromptLibraryModal: (prompt: string, source: PromptLibraryItemSource) => void;
  closeCreatePromptLibraryModal: () => void;
  createPromptLibraryModalState: { prompt: string; source: PromptLibraryItemSource } | null;
  promptToApply: PromptToApply | null;
  setPromptToApply: (value: PromptToApply | null) => void;
}

export const PromptLibraryContext = createContext<PromptLibraryContextState>({
  subscribe: () => () => {},
  emit: () => {},
  openCreatePromptLibraryModal: () => {},
  closeCreatePromptLibraryModal: () => {},
  createPromptLibraryModalState: null,
  promptToApply: null,
  setPromptToApply: () => {},
});

export const usePromptLibraryContext = () => {
  const context = useContext(PromptLibraryContext);

  if (!context) {
    throw new Error("usePromptLibraryContext must be used within a PromptLibraryContextProvider");
  }

  return context;
};
